import { Injectable } from '@angular/core';
import { GalleryIntl } from '@knorr-bremse-portals/ngx-components/components/gallery';

@Injectable({providedIn: 'root'})
export class LocalGalleryIntl extends GalleryIntl {

  public override previousPageButtonLabel = $localize `:gallery previous page button label@@:Previous page`;
  public override nextPageButtonLabel = $localize `:gallery next page button label@@:Next page`;

}
